module.exports = __webpack_public_path__ + "img/best_3.1f8e6cc3.svg";